<template>
  <v-row>
    <v-col cols="12" md="6">
      <v-form :submit="submitUpdate">
        <v-row>
          <v-col cols="12" sm="6">
            <AutocompleteSelectInvoiceStatus
                                             :user="user"
                                             label="Situação"
                                             :statuses="[$INVOICE_STATUSES[1], $INVOICE_STATUSES[4]]"
                                             v-model="value.status" />
          </v-col>
          <v-col cols="12" sm="6" v-if="value.status == $INVOICE_STATUS_DIC.PAID.value">
            <AutocompleteSelectPaymentMethod
                                             :user="user"
                                             label="Forma de pagamento"
                                             v-model="value.payment_method"
                                             online-only
                                             return-object />
          </v-col>
          <v-col cols="12">
            <v-text-field
                          label="Código Referência"
                          v-model="value.ref"
                          hide-details></v-text-field>
          </v-col>
          <v-col cols="12">
            <v-textarea
                        label="Histórico"
                        v-model="value.description"
                        hide-details></v-textarea>
          </v-col>
          <v-col cols="12" class="text-right">
            <v-btn color="success" type="submit">
              <v-icon class="mr-2">mdi-content-save</v-icon>
              Pagar
            </v-btn>
          </v-col>
        </v-row>
      </v-form>
    </v-col>
    <v-col cols="12" md="6">
      <h1>Detalhes</h1>
      {{ value }}
    </v-col>
  </v-row>
</template>
<script>
import AutocompleteSelectInvoiceStatus from "./AutocompleteSelectInvoiceStatus.vue";
import AutocompleteSelectPaymentMethod from "./AutocompleteSelectPaymentMethod.vue";
import api from '@/services'
export default {
  components: {
    AutocompleteSelectPaymentMethod,
  },
  props: {
    user: Object,
    modelValue: Object,
  },
  emits: ["update:modelValue"],
  data() {
    return {
      requestingApi: null,
      rules: {
        required: [(v) => !!v || "Campo obrigatório"],
      },
    };
  },
  created() {
    var vm = this;
    if (!vm.modelValue?.status) {
      vm.value.status = vm.$INVOICE_STATUS_DIC.PAID.value;
    }
  },
  mounted() { },
  methods: {
    submitUpdate() {
      var vm = this;
      vm.requestingApi = true;
      return new Promise((resolve, reject) => {
        if (true) {
          console.log("vm.modelValue");
          resolve(true);
        } else {
          reject(false);
        }
        // api.invoice
        //   .writeOff(vm.modelValue)
        //   .then((result) => {
        //     vm.$emit("created", result);
        //     vm.$notify({
        //       type: "success",
        //       text: "Dados alterados com sucesso",
        //     });
        //   })
        //   .catch((err) => {
        //     if (err.message) {
        //       vm.$notify({
        //         type: "warn",
        //         text: err.message,
        //       });
        //     }
        //   })
        //   .finally(() => {
        //     vm.requestingApi = false;
        //   });
      });
    },
  },
  computed: {
    value: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit("update:modelValue", value);
      },
    },
  },
  watch: {},
};
</script>